module.exports = [
  'DRAFT', // to be delete
  'OPEN', // to be delete
  'CLOSED', // to be delete
  'FINISHED',
  'PRIVATE',
  'PUBLIC'
];
